var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256 128C256 198.692 198.692 256 128 256C57.3076 256 0 198.692 0 128C0 57.3075 57.3076 0 128 0C198.692 0 256 57.3075 256 128ZM141.642 139.791V139.812V139.833C172.819 138.433 196.094 133 196.094 126.497C196.094 119.995 172.84 114.562 141.642 113.162V134.4C140.737 134.482 135.88 134.894 126.167 134.894C118.08 134.894 112.215 134.544 110.177 134.4V113.142C78.9389 114.521 55.6026 119.974 55.6026 126.477C55.6026 133 78.9183 138.433 110.177 139.812V139.791C112.194 139.894 117.895 140.121 126.023 140.121C136.189 140.121 140.758 139.853 141.642 139.791ZM141.642 91.9457V110.96L141.663 110.981C176.976 112.607 203.523 119.624 203.523 128C203.523 136.396 176.976 143.393 141.663 145.018V205.973H110.198V145.018C74.8436 143.372 48.2354 136.375 48.2354 127.979C48.2354 119.583 74.823 112.586 110.198 110.96V91.9457H66.6738V62.9502H185.167V91.9457H141.642Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.ca3cd047.svg";
export { ForwardRef as ReactComponent };